import { render } from "./endActivity.vue?vue&type=template&id=2a8e71c3&scoped=true&lang=html"
import script from "./endActivity.vue?vue&type=script&lang=js"
export * from "./endActivity.vue?vue&type=script&lang=js"

import "./endActivity.vue?vue&type=style&index=0&id=2a8e71c3&lang=less&scoped=true"

import exportComponent from "/Users/zhangmohan/work/activitymarketing-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8e71c3"]])

export default __exports__